import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {ToasterService} from "../../../services/core/toaster.service";
import {SharedService} from "../../shared/shared.service";
import {HtmlService} from "../../../services/core/html.service";
import {NgDialogAnimationService} from 'src/app/services/core/ng-dialog-animation.service';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {first} from "rxjs/operators";
import {JobsiteDataService} from "../jobsite.data.service";
import {WarehouseDataService} from "../../inventory/warehouse/warehouse.data.service";
import {WarehouseService} from "../../inventory/warehouse/warehouse.service";
import {MatStepper} from "@angular/material/stepper";
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";
import {ModuleDataMilestoneService} from "../../../services/module-data-milestone.service";

@Component({
    selector: 'app-create-jobsite',
    templateUrl: './create-jobsite.component.html',
    styleUrls: ['./create-jobsite.component.scss'],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { showError: true },
        },
    ],
    standalone: false
})
export class CreateJobsiteComponent implements OnInit, AfterViewInit {
  public isSaving = false;

  @Output() callback = new EventEmitter<any>(true);
  @ViewChild('stepper') stepperRef!: MatStepper;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  public submitted = false;
  public model:any ={};
  public customerTypes:any;
  public warehouseForm!: UntypedFormGroup;
  public step:any;
  public finalPreview = false;
  public id: string = '';
  public isEdit:boolean = false;
  public initialStepIndex = 0;
  public defaultTitle = '';

  /** Module id of the Job Site module — used for milestone auto-deploy. */
  private readonly JOBSITE_MODULE_ID = 29;

  constructor(
    public fb: UntypedFormBuilder,
    public toasterService: ToasterService,
    private jobsiteDataService: JobsiteDataService,
    public sharedService: SharedService,
    private htmlService: HtmlService,
    public warehouseDataService: WarehouseDataService,
    public warehouseService: WarehouseService,
    public dialog: NgDialogAnimationService,
    private cd: ChangeDetectorRef,
    private moduleDataMilestoneService: ModuleDataMilestoneService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateJobsiteComponent>,
  ) {
    this.model = this.data?.model;
    this.id = this.data?.model?.id;
    this.isEdit = this.data?.edit;
    this.initialStepIndex = 0;
    this.defaultTitle = this.data?.bidName || this.data?.default_title || '';
  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }
  ngOnInit(): void {
    this.initWarehouseForm();
    this.prefillJobSiteName();
  }

  ngAfterViewInit(): void {
    const defaultName = this.data?.bidName || this.data?.default_title;
    if (!defaultName) return;
    setTimeout(() => {
      this.stepperRef.selectedIndex = 1;
      this.cd.detectChanges();
    }, 0);
  }

  prefillJobSiteName(): void {
    const defaultName = this.data?.bidName || this.data?.default_title;
    if (!defaultName) return;
    const wareHouseControl = this.warehouseForm.get('step01')?.get('wareHouse');
    if (wareHouseControl) {
      wareHouseControl.setValue({
        name: defaultName,
        email: null,
        phone: null,
        fax: null
      }, { emitEvent: true });
    }
  }

  initWarehouseForm(){
    this.warehouseForm = new UntypedFormGroup({
      step01: new UntypedFormGroup({
        wareHouse: new UntypedFormControl(null),
      }),
      step02: new UntypedFormGroup({
        wareHouseDetail: new UntypedFormControl(null),
      }),
    });
  }
  initChildForm(step: string, formControlName: string, value:any){
    this.warehouseForm.get(step)?.get(formControlName)?.setValue(value);

  }
  onStepChanged = (event:any, stepper:any) => {
    this.step = {event:event, stepper:stepper};

  }
  touchFormControls(formControlName: string, secondFormControlName: any = null){
    let warehouseForm = this.warehouseForm.get(formControlName);
    // @ts-ignore
    warehouseForm = secondFormControlName ? warehouseForm?.get(secondFormControlName) : warehouseForm;
    warehouseForm?.markAsTouched()
    warehouseForm?.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }

  onSubmit() {
    // Re-entrancy guard: the whole stepper lives in one <form>, so pressing Enter in any
    // field fires (ngSubmit) directly — bypassing the Create button's [disabled]="isSaving"
    // binding and risking a duplicate create request while one is already in flight.
    if (this.isSaving) {
      return;
    }
    if (this.warehouseForm.invalid) {
      this.toasterService.showWarning('Please fill all required field.');
      return;
    }
    const isCreate = !this.id;
    const  service = this.id ?
      this.jobsiteDataService.update(this.model.id , this.getFormData()) :
      this.jobsiteDataService.create(this.getFormData());

    this.isSaving = true;
    service
      .pipe(first(), finalize(() => (this.isSaving = false)))
      .subscribe(
        data => {
          this.callback.emit(data);
          this.warehouseForm.reset();
          if (isCreate) {
            const newJobsiteId = data?.data?.data?.id;
            if (newJobsiteId) {
              this.autoDeployMilestones(newJobsiteId);
            }
          }
          this.close(data);
          this.toasterService.showSuccessMessage(data?.data.message);
        });
  }

  /**
   * After a jobsite is created, attach the Job Site module's auto-deploy milestone
   * template (if one is enabled). Fire-and-forget — failures are logged silently and
   * never block the create flow.
   */
  private autoDeployMilestones(jobsiteId: number) {
    this.moduleDataMilestoneService
      .autoDeploy(this.JOBSITE_MODULE_ID, jobsiteId)
      .pipe(first())
      .subscribe({
        next: () => {},
        error: (err) => {
          console.error('Milestone auto-deploy failed for jobsite', jobsiteId, err);
        }
      });
  }
  getFormData = () => {
    const formValue = this.warehouseForm.value;
    const payload = {
      title: formValue.step01.wareHouse.name,
      email: formValue.step01.wareHouse.email,
      phone: formValue.step01.wareHouse.phone,
      fax: formValue.step01.wareHouse.fax,
      address: formValue.step02.wareHouseDetail.main_address.address_line_1,
      address2: formValue.step02.wareHouseDetail.main_address.address_line_2,
      city: formValue.step02.wareHouseDetail.main_address.city,
      state_id: formValue.step02.wareHouseDetail.main_address.state_id.id,
      zipcode: formValue.step02.wareHouseDetail.main_address.zipcode,


      country_id: 231,

    };
    return payload;
  }

  close = (data : any = '') => {
    this.dialogRef.close(data);
  }
  finalPreviewFn(stepper: MatStepper){
    this.touchFormControls('step02','wareHouseDetail');
    // @ts-ignore
    const isInvalid =this.warehouseForm.get('step02').get('wareHouseDetail').invalid;
    console.log('isInvalid' , isInvalid);
    // @ts-ignore
    console.log('jobsite' , this.warehouseForm.get('step02').get('wareHouseDetail'));
    if (!isInvalid){
      stepper.next();
    }

  }
  cancelPreview(){
    this.finalPreview = false;
    this.step.event.selectedIndex = 2;
  }

  checkFormValidity(formName: any){
    return this.warehouseForm.get(formName)?.invalid;
  }
}
